module.exports = __webpack_public_path__ + "static/media/banner5.c541203f.png";